import React, { useState, useEffect, useRef } from 'react';

const LANG_OPTIONS = [
  { value: 'uk', label: 'Українська' },
  { value: 'en', label: 'English'    },
];

function LangDropdown({ lang, onChange, dropUp = false }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const h = e => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('keydown', h);
    return () => document.removeEventListener('keydown', h);
  }, [open]);

  return (
    <>
      {/* Десктоп/планшет (≥992px) — кастомний pill-дропдаун, як і раніше */}
      <div ref={ref} className={`ctrl-dropdown lang-dropdown d-none d-lg-inline-flex${open ? ' ctrl-dropdown--open' : ''}${dropUp ? ' ctrl-dropdown--up' : ''}`}>
        <button type="button" className="ctrl-dropdown-trigger-lang"
          onClick={() => setOpen(v => !v)}
          aria-haspopup="listbox" aria-expanded={open} title="Вибір мови">
          <i className="fa-solid fa-earth-europe lang-dropdown-icon--desktop" aria-hidden="true" />
          <i className="fa-solid fa-chevron-down ctrl-dropdown-chevron" aria-hidden="true" />
        </button>
        <ul className="ctrl-dropdown-menu" role="listbox">
          {LANG_OPTIONS.map(opt => {
            const isActive = opt.value === lang;
            return (
              <li key={opt.value} role="option" aria-selected={isActive}
                className={`ctrl-dropdown-item${isActive ? ' ctrl-dropdown-item--active' : ''}`}
                onClick={() => { onChange(opt.value); setOpen(false); }}>
                <span>{opt.label}</span>
                {isActive && <i className="fa-solid fa-check ctrl-dropdown-item-check" aria-hidden="true" />}
              </li>
            );
          })}
        </ul>
        {open && (
          <div className="ctrl-dropdown-mobile-overlay" onClick={() => setOpen(false)} />
        )}
      </div>

{/* Мобіл (<992px) — справжній <select>, повністю прозорий і накладений
          на іконку глобуса: видно лише іконку, але тап все одно відкриває
          нативний список ОС (iOS/Android) із повними назвами мов */}
      <div className="lang-dropdown-native-wrap d-lg-none" title="Вибір мови">
        <i className="fa-solid fa-earth-europe lang-dropdown-icon--mobile" aria-hidden="true" />
        <select
          className="lang-dropdown-native"
          value={lang}
          onChange={e => onChange(e.target.value)}
          aria-label="Вибір мови"
        >
          {LANG_OPTIONS.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>
    </>
  );
}

export default LangDropdown;
